(function () {
  if (window.__rfQuickAddInit) return;   // only run once, even though this file loads per card
  window.__rfQuickAddInit = true;

  // Live price update on size selection
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.rf-qa__opts input[type="radio"]')) return;
    var root = input.closest('[data-rf-qa]');
    if (!root) return;
    var now = root.querySelector('.rf-qa__price-now');
    var was = root.querySelector('.rf-qa__price-was');
    if (now && input.dataset.now) now.textContent = input.dataset.now;
    if (was) {
      if (input.dataset.was) { was.textContent = input.dataset.was; was.style.display = ''; }
      else { was.style.display = 'none'; }
    }
  });

  // Add to cart in the background, refresh the drawer, then open it
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('[data-rf-qa]');
    if (!form) return;
    e.preventDefault();
    if (form.dataset.rfBusy === '1') return;   // ignore repeat clicks while adding
    form.dataset.rfBusy = '1';

    var btn = form.querySelector('.rf-qa__add');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    try {
            var idInput = form.querySelector('input[name="id"]:checked')
                 || form.querySelector('input[name="id"][type="hidden"]');
      var variantId = idInput ? idInput.value : null;
      if (!variantId) throw new Error('no variant');

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
            var itemsEl = document.querySelector('cart-items-component');
      var sectionId = itemsEl ? itemsEl.getAttribute('data-section-id') : 'cart-drawer';
      if (sectionId) {
        var html = await fetch('/?section_id=' + encodeURIComponent(sectionId)).then(function (r) { return r.text(); });
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newItems = doc.querySelector('cart-items-component');
        var curItems = document.querySelector('cart-items-component');
        if (newItems && curItems) curItems.replaceWith(newItems);
        var newIcon = doc.querySelector('cart-icon');
        var curIcon = document.querySelector('cart-icon');
        if (newIcon && curIcon) curIcon.replaceWith(newIcon);
              var dlg = document.querySelector('cart-drawer-component dialog');
      if (dlg) {
        dlg.classList.remove('cart-drawer--empty');
        dlg.setAttribute('aria-labelledby', 'cart-drawer-heading');
      }
      }

      var drawer = document.querySelector('cart-drawer-component');
      var dialog = drawer ? drawer.querySelector('dialog') : null;
      if (dialog && typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        window.location.href = '/cart';
      }
    } catch (err) {
      window.location.href = '/cart';
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original; }
      form.dataset.rfBusy = '0';
    }
  });
})();
document.addEventListener('DOMContentLoaded', function () {
  var s = document.querySelector('.cbd-text-section');
  if (!s) return;
  s.style.maxHeight = '200px';
  s.style.overflow = 'hidden';
  s.style.position = 'relative';
  var b = document.createElement('button');
  b.textContent = 'See more';
  b.style.cssText = 'position:absolute;bottom:0;left:0;right:0;padding:40px 0 12px;border:0;background:linear-gradient(transparent,#fff 60%);color:#0B3D2E;font-size:13px;cursor:pointer';
  s.appendChild(b);
  b.addEventListener('click', function () {
    var open = s.style.maxHeight === 'none';
    s.style.maxHeight = open ? '200px' : 'none';
    b.textContent = open ? 'See more' : 'See less';
    b.style.background = open ? 'linear-gradient(transparent,#fff 60%)' : 'none';
    b.style.paddingTop = open ? '40px' : '12px';
  });
});
